import { BoxProps, ButtonProps, CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const ButtonOutsideArea = {
  display: 'none',
};

export const FlexContainer = (): CSSObject => ({
  px: ['2.5', null, null, '0'],
});

export const BoxWrapper: BoxProps = {
  pr: '0',
};

export const buttonLogInProps: ButtonProps = {
  variant: 'solid',
  height: '46px',
};

export const buttonSignUpProps: CustomButtonProps = {
  variant: 'primary',
  height: '46px',
};

export const buttonQuickAccessProps: CustomButtonProps = {
  variant: 'quickAccess',
  height: '46px',
  p: '2.5',
  sx: {
    '.btn-span': {
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      fontWeight: 'normal',
      mr: '1',
      gap: '0',
      mt: '0.5',
    },
    '.span-balance': {
      fontSize: 'md',
      lineHeight: '14px',
      color: 'blackAlpha.700',
      textShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.35)',
    },
    '.span-bonus': {
      fontFamily: 'body',
      fontSize: '2xs',
      lineHeight: '10px',
      fontWeight: 'extrabold',
      color: 'blackAlpha.700',
      textShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.35)',
      alignSelf: 'start',
    },

    'svg:not(.chevron-icon)': {
      pos: 'relative',
      top: '0.5',
      mr: '0.5',
    },
    '.chevron-icon': {
      pos: 'absolute',
      right: '1.5',
      top: '0',
      bottom: '0',
      margin: 'auto 0',
      color: 'blackAlpha.700',
    },

    '&&[aria-expanded="true"]': {
      '.span-balance': {
        color: 'alpha.900',
      },
      '.span-bonus': {
        color: 'alpha.900',
      },
      '.chevron-icon': { transform: 'rotate(180deg)', color: 'alpha.900' },

      zIndex: 'dropdown',
    },
  },
};

export const buttonBetsProps: ButtonProps = {
  variant: 'bets',
  height: '46px',
  p: '3',
  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '2',
    },
    '.span-bet': {
      fontWeight: 'normal',
      fontSize: 'xs',
      color: 'blackAlpha.700',
    },
    '.span-bet-count': {
      fontWeight: 'normal',
      fontSize: 'lg',
      color: 'blackAlpha.700',
    },
  },
};

export const buttonBetSlipProps: ButtonProps = {
  variant: 'bets',
  height: '46px',
  p: '3',
  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '2',
    },
  },
};

export const IconButtonMenu = (): CSSObject => ({
  bg: 'transparent',
  color: 'gamma.600',
  boxSize: '8',
  ml: '-1',

  '& svg': {
    boxSize: '8',
  },
});

export const FlexLeftGroup: CSSObject = {
  gap: '1.5',
  justifyContent: 'flex-start',
  alignItems: 'center',
};

export const ButtonGroupBets: CSSObject = {
  gap: '0.5',

  '> .chakra-button ~ .chakra-button': {
    marginInlineStart: 0,
  },
  '>*:first-of-type:not(:last-of-type)': {
    borderRightRadius: 'md',
  },
  '>*:not(:first-of-type):last-of-type': {
    borderLeftRadius: 'md',
  },
};

export const ButtonBetSlip: CSSObject = {
  ml: '0',
};

export const ButtonGroup: CSSObject = {
  gap: '1',
};

export const LinkLogo: CSSObject = {
  display: ['block', null, null, 'none'],
  ml: '-2',
};

export const TextButton: CSSObject = {
  fontWeight: 'normal',
  fontSize: 'xs',
  color: 'blackAlpha.700',
};

export const TextButtonNumber: CSSObject = {
  fontWeight: 'normal',
  fontSize: 'lg',
  color: 'blackAlpha.700',
};
